import { GenericBottomSheetTakeover } from '@varo/graphql-schema-types';
import bottomSheetTakeovers from 'services/graphql/queries/BottomSheetTakeovers.query';
import { useQuery } from 'urql';

const useGetDDBottomSheetContent = ({ skip }: { skip: boolean }) => {
  const [{ data, error, fetching }] = useQuery<{
    bottomSheetTakeovers: GenericBottomSheetTakeover;
  }>({
    query: bottomSheetTakeovers,
    variables: {
      filter: {
        types: 'ALL_STEPS_COMPLETED',
      },
    },
    pause: skip,
    requestPolicy: 'network-only',
  });

  const bottomSheetData = data
    ?.bottomSheetTakeovers?.[0] as GenericBottomSheetTakeover;

  return {
    bottomSheetData,
    error,
    fetching,
  };
};

export default useGetDDBottomSheetContent;
